import { crossHostSignup } from '@/lib/cross-host-redirect';
import { getValidRedirect } from '@/lib/redirectValidation';

/**
 * Builds the cross-host signup URL with a sanitized `?next=` redirect target.
 *
 * Pre-Plan-4 this returned a relative `/signup?redirect=...` path. Now returns
 * `https://app.loci.city/signup?next=<validated>` because `/signup` lives on
 * the app surface and any caller from a city marketing host needs to cross
 * domains. Same-host callers on the app surface get a fully-qualified URL too;
 * Next.js `<Link href>` and `router.push` both accept absolute URLs and treat
 * them as hard navigations when the host differs.
 */
export function buildSignupWithRedirect(returnPath: string | null): string {
  const validated = getValidRedirect(returnPath, '__INVALID__');
  if (validated === '__INVALID__') return crossHostSignup();
  // Forward the *validated* path so the sanitization is the source of truth
  // for what reaches the cross-host signup URL.
  return crossHostSignup(validated);
}
